import type { Language, SurveyLanguage } from '@webapp/common/resources/entities/language';

export interface MultiLangState {
    isAllLanguagesLoaded: boolean;
    allLanguages: Array<Language>;
    surveyLanguages: Array<SurveyLanguage>;
}

export const initialState: Readonly<MultiLangState> = {
    isAllLanguagesLoaded: false,
    allLanguages: [],
    surveyLanguages: [],
};
